export const scrollToATWLAlert = () => {
  if ($('.modal-quickview').length == 0) {
    let wlAlert = '.new-WLalert';
    const scroll_atwl = (px) => {
      $('html,body').animate({
        scrollTop: $(wlAlert).offset().top - px
      }, 500);
    };
    if ($(wlAlert).length > 0) {
      var px;
      if ($('.mobilePage').length > 0) {
        //Mobile View
        px = 15;
      } else {
        //Desktop View
        if ($('.sticky-nav-bg').is(':visible')) {
          //Desktop View w/ Stick Nav
          px = 90;
        } else {
          //Desktop View w/out Stick Nav
          px = 130;
        }
      }
      scroll_atwl(px);
      $(wlAlert).removeClass(wlAlert);
    }
  }
}
